import React from "react";

import { useURLParamsGetter } from "~/hooks/useURLParamsSetter";
import { usePermissions } from "~/shared/context/PermissionContext";

import LicenseAssignModal from "./components/LicenseAssignModal";
import LicenseRevokeModal from "./components/LicenseRevokeModal";

export type LicenseActionsModalType = "LicenseAssign" | "LicenseRevoke";

const LicenseActionsModals = () => {
  const { openModal } = useURLParamsGetter<{
    openModal?: LicenseActionsModalType;
  }>();
  const { hasPermission, hasSomePermission } = usePermissions();

  return (
    <>
      <LicenseAssignModal
        isOpen={
          openModal === "LicenseAssign" &&
          hasPermission("employeeAccounting.licenses.assign.post")
        }
      />
      <LicenseRevokeModal
        isOpen={
          openModal === "LicenseRevoke" &&
          hasSomePermission([
            "employeeAccounting.licenses.revoke.post",
            "employeeAccounting.licenses.mass-revoke.post",
          ])
        }
      />
    </>
  );
};

export default LicenseActionsModals;
